import { useEffect, useState } from 'react'

import { getRecentSetlists, getRecentSongs } from '../../utils/recents'

let songInterval
export const useRecentSongs = () => {
  const [songs, setSongs] = useState([])

  useEffect(() => {
    songInterval = setInterval(() => {
      const data = getRecentSongs()
      setSongs(data)
    }, 2500)

    return () => clearInterval(songInterval)
  }, [])

  return songs
}

let setsInterval
export const useRecentSets = () => {
  const [sets, setSets] = useState([])
  useEffect(() => {
    setsInterval = setInterval(() => {
      setSets(getRecentSetlists())
    }, 2500)

    return () => clearInterval(setsInterval)
  }, [])

  return sets
}

export const useRecents = (type = 'songs') => {
  if (type === 'songs') {
    return useRecentSongs()
  }
  return useRecentSets()
}
